module.exports = __webpack_public_path__ + "img/germany.4fe4ba5f.svg";